// extracted by mini-css-extract-plugin
module.exports = {"nav":"Colleges_nav__ftFrD","button":"Colleges_button__x8YHw","active":"Colleges_active__jseNS","team":"Colleges_team__wSCAd","teamWrapper":"Colleges_teamWrapper__Jmahh"};